import { Routes, Route } from "react-router-dom";
import PlannerList from "./PlannerList";
import PlannerForm from "./PlannerForm";
import NextDayPlanner from "./NextDayPlanner";
import PaymentsDashboard from "./PaymentsDashboard";
import UpcomingDates from "./UpcomingDates";

export default function Planner() {
  return (
    <Routes>
      <Route path="/"         element={<PlannerList />} />
      <Route path="upcoming"  element={<UpcomingDates />} />
      <Route path="next-day"  element={<NextDayPlanner />} />
      <Route path="payments"  element={<PaymentsDashboard />} />
      <Route path="new"       element={<PlannerForm />} />
      <Route path="edit/:id"  element={<PlannerForm />} />
    </Routes>
  );
} //033 40071212; rpo kolkata
